export {
  supportedLanguages,
  RTL_LANGUAGES,
  defaultLanguage,
  type AllTenantsSupportedLanguages,
  type Language,
} from './i18n-config';

export { useClientTranslation, useClientLocale } from './client-hooks';

export {
  initServerTranslation,
  getServerLocale,
  getUserDataAndLocale,
} from './server-translation';

export { interpolateTranslation } from './interpolateTranslation';

export { getPluralTranslationKey } from './getPluralTranslationKey';

export {
  ServerLanguageProvider,
  setClientLanguage,
} from './LanguageContext/LanguageContext';

export { useServerLanguage } from './LanguageContext/useServerLanguage';

export {
  getLocale,
  getCurrentLocale,
  getAllSupportedLocales,
  isLocaleSupported,
  getLanguageFromLocale,
  isSupportedLanguage,
  languageTitleByCode,
  defaultLocale,
  isRtlLanguageFromLocale,
} from './locale';

export type Locale = string;

import { useI18n, initI18n } from './client-translation';

export { useI18n, initI18n };
